import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import {
  Avatar,
  AvatarSize,
} from "@whoosh/design-system/src/components/display";

import { InstructorPhotoFragment_staffProfile$key } from "./__generated__/InstructorPhotoFragment_staffProfile.graphql";

type Props = {
  instructorRef: InstructorPhotoFragment_staffProfile$key | null;
  size?: AvatarSize;
};
export const InstructorPhoto = ({ instructorRef, size = "lg" }: Props) => {
  const instructor = useFragment(InstructorPhotoFragmentString, instructorRef);

  const firstName = instructor?.user?.firstName || "";
  const lastName = instructor?.user?.lastName || "";
  const imagePublicId = instructor?.profileImage?.publicId;

  return (
    <Avatar
      firstName={firstName}
      lastName={lastName}
      type="secondary"
      profileImagePublicId={imagePublicId}
      size={size}
    />
  );
};

const InstructorPhotoFragmentString = graphql`
  fragment InstructorPhotoFragment_staffProfile on StaffProfile {
    profileImage {
      # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
      publicId: renderingKey
    }
    user {
      fullName
      firstName
      lastName
    }
  }
`;
